import { TAG } from "../constants";
import { WeightLogger } from "../types";
import { patientApi } from "./patientApi";

export const batchesApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getWeightLogger: builder.query<WeightLogger, void>({
      query: () => ({
        method: "GET",
        url: `/api/batches/weight-logger`,
      }),
      providesTags: [TAG.BATCH, TAG.PATIENT_WEIGHTS, TAG.PATIENT_COUPONS],
    }),
  }),
});

export const { useGetWeightLoggerQuery } = batchesApi;
